import Table from './TableBox';
import {
  IActionRows,
  IColumn,
  IRow,
  IRowAction,
  ISelectBoxActions,
  PropType,
  ITableProps,
  TableCellProps,
} from './TableBox/types';

export { Table };
export type {
  IActionRows,
  IColumn,
  IRow,
  IRowAction,
  ISelectBoxActions,
  PropType,
  ITableProps,
  TableCellProps,
};
